import { SB } from '@play-co/replicant';

export const progressionSchema = {
  progression: SB.object({
    currentStage: SB.string(),
    completedTiers: SB.map(SB.string()),
    lastUpdated: SB.int(),
  }).optional(),
};
